(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('free-shipping-bar')) {
    class FreeShippingBar extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('.pk-fsb__text');
        this.slide = 0;
        try {
          this.offers = JSON.parse(this.dataset.offers).map((offer) => offer.trim()).filter(Boolean);
        } catch (e) {
          this.offers = [];
        }
        this.update(parseInt(this.dataset.total, 10) || 0, this.dataset.currency);
        this.watchCart();
        this.startRotation();
      }

      disconnectedCallback() {
        clearInterval(this.rotation);
      }

      format(cents, currency) {
        const whole = cents % 100 === 0;
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency,
            minimumFractionDigits: whole ? 0 : 2,
            maximumFractionDigits: whole ? 0 : 2,
          }).format(cents / 100);
        } catch (e) {
          return (cents / 100).toFixed(whole ? 0 : 2);
        }
      }

      amountNode(text) {
        const amount = document.createElement('span');
        amount.className = 'pk-fsb__amount';
        amount.textContent = text;
        return amount;
      }

      // Nodes of slide 0 = the free shipping message, rebuilt on every cart change.
      update(total, currency) {
        const rate = currency === this.dataset.shopCurrency ? 1 : parseFloat(window.Shopify?.currency?.rate || '0');
        const shopThreshold = parseInt(this.dataset.threshold, 10);
        if (!rate || !shopThreshold) {
          this.shipping = null;
        } else {
          const threshold = Math.round(shopThreshold * rate);
          const remaining = threshold - total;
          if (total <= 0) {
            this.shipping = ['Free shipping for orders over ', this.amountNode(this.format(threshold, currency))];
          } else if (remaining > 0) {
            this.shipping = ['Only ', this.amountNode(this.format(remaining, currency)), ' away from free shipping'];
          } else {
            this.shipping = ["\u{1F389} You've unlocked free shipping!"];
          }
        }
        this.hidden = !this.shipping && !this.offers.length;
        if (this.slide === 0) this.show();
      }

      // "Any 4 items: *5% off*" -> text with the starred part in the amount colour
      offerNodes(offer) {
        return offer.split('*').map((part, index) => (index % 2 ? this.amountNode(part) : part));
      }

      slides() {
        const slides = this.offers.map((offer) => () => this.offerNodes(offer));
        if (this.shipping) slides.unshift(() => this.shipping);
        return slides;
      }

      show() {
        const slides = this.slides();
        if (!slides.length) return;
        this.slide %= slides.length;
        this.text.replaceChildren(...slides[this.slide]());
      }

      startRotation() {
        const seconds = parseFloat(this.dataset.interval) || 2;
        if (this.slides().length < 2) return;
        this.rotation = setInterval(() => {
          if (document.hidden) return;
          this.text.classList.add('is-fading');
          setTimeout(() => {
            this.slide += 1;
            this.show();
            this.text.classList.remove('is-fading');
          }, 250);
        }, seconds * 1000);
      }

      // Dawn re-renders #cart-icon-bubble after every add / quantity change / removal,
      // whichever code path made the change (product form, cart drawer, upsell, apps).
      watchCart() {
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        let timer;
        new MutationObserver(() => {
          clearTimeout(timer);
          timer = setTimeout(() => this.refresh(), 150);
        }).observe(bubble, { childList: true, subtree: true, characterData: true });
      }

      async refresh() {
        try {
          const cart = await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((response) => response.json());
          this.update(cart.total_price, cart.currency);
        } catch (e) {
          // keep the current text
        }
      }
    }

    customElements.define('free-shipping-bar', FreeShippingBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
